/**
 * Region filter for the station grid. Every station is already on the page, so
 * this just shows and hides the cards.
 */
export default class StationFilter {
	constructor() {
		document
			.querySelectorAll('[data-station-filter]')
			.forEach(section => this.#setup(section))
	}

	#setup(section) {
		const select = section.querySelector('[data-station-region]')
		if (!select) return

		const cards = section.querySelectorAll('[data-station-card]')
		const empty = section.querySelector('[data-station-empty]')

		const apply = () => {
			let visible = 0

			cards.forEach(card => {
				const match =
					select.value === 'all' || card.dataset.region === select.value
				card.classList.toggle('hidden', !match)
				if (match) visible++
			})

			empty?.classList.toggle('hidden', visible > 0)
		}

		select.addEventListener('change', apply)

		section
			.querySelector('[data-station-reset]')
			?.addEventListener('click', event => {
				event.preventDefault()
				select.value = 'all'
				apply()
			})

		apply()
	}
}
